import React, { useEffect, useState } from "react";
import "./SearchBarStyles.css";
import { Loader, TagInput, TagPicker } from "rsuite";
import usePost from "../../../customhooks/UsePost";
// import SpinnerIcon from "@rsuite/icons/legacy/Spinner";
import { Trans, useTranslation } from "react-i18next";
import { useLoaderData } from "react-router-dom";


function SmallSearchKey({
  values,
  setValues,
  SearchBodyData,
  suggestions,
  setSuggestions,
  getSuggetions,
  loading,
}) {
    const { t } = useTranslation();
  let loaderDetails = useLoaderData()
  const [words, setWords] = useState("");
  const fetchdata = (word) => {
    setWords(word);

    let body = {
      searchkey: word ?? "",
      companyID: loaderDetails?.companyID,
    };

    getSuggetions(body).then((res) => {
      const updatedSuggestions = res?.data?.result?.map(
        (suggestions, index) => ({
          label: suggestions?.label,
          key: index,
          value: suggestions?.label,
          match_type: suggestions?.match_type,
        })
      );
      // const UpdateDate = res?.data?.result?.map((x) => {
      //   return { label: x, value: x };
      // });

      setSuggestions(updatedSuggestions);

      // console.log(res?.data?.result);
    });
  };
  const [cacheData, setCacheData] = React.useState([]);

  const handleSelect = (value, item, event) => {
    setCacheData([...cacheData, item]);
    setValues([...values, item]);
  };
  // console.log(SearchBodyData);
  //   useEffect(() => {
  //     const UpdateDate = SearchBodyData?.searchKey?.map((x) => {
  //       return { label: x, value: x };
  //     });
  //     setSuggestions(UpdateDate);
  //     // const updatedValues = Array.isArray(values) ? values : [];
  //     // setValues(UpdateDate);
  //   }, [SearchBodyData]);

  const handleChange = (newValues) => {
    // console.log(newValues);
    let updatedValues;
    if (Array.isArray(newValues)) {
      updatedValues = newValues;
    } else if (newValues) {
      updatedValues = [newValues];
    } else {
      updatedValues = [];
    }
    setValues(updatedValues);
  };

  return (
      <div className="search-bar-container">
        <TagPicker
          creatable={suggestions?.length <= 0}
          className=" no-border d-block"
          onCreate={(value, item) => {
            // console.log(value, item);
          }}
          data={suggestions ?? []}
          cacheData={cacheData}
          value={values}
          // defaultValue={values}
          labelKey="label"
          valueKey="value"
          onChange={handleChange}
          onSearch={fetchdata}
          onSelect={handleSelect}
          block
          placeholder={t("enterSkills,Designations,Keywords", { defaultValue: "Enter skill designations keywords" })}
          renderMenuItem={(item, values) => {
            return (
              <div className="w-100">
                {loading ? (
                  <p style={{ padding: 4, color: "#999", textAlign: "center" }}>
                    <Loader /> Loading...
                  </p>
                ) : (
                  <>
                    {values?.match_type == "skills" && (
                      <div className="d-flex justify-content-between textOverFlow">
                        <span className="mx-1 textOverFlow campagnLabel">
                          {item}
                        </span>
                        <span className="ProfileTitle">
                          <Trans i18nKey="skills" defaults="Skills" />
                        </span>
                      </div>
                    )}
                    {values?.match_type == "job_titles" && (
                      <div className="d-flex justify-content-between textOverFlow">
                        <span className="textOverFlow campagnLabel">{item}</span>
                        <span
                          className="ProfileTitle"
                          style={{ marginLeft: "-5px" }}
                        >
                          <Trans i18nKey="jobTitle" defaults="Job Title" />
                        </span>
                      </div>
                    )}
                    {suggestions?.length == 0 && (
                      <span className="textOverFlow campagnLabel">{item}</span>
                    )}
                  </>
                )}
              </div>
            );
          }}
        />
      </div>
  );
}

export default SmallSearchKey;
